
<div>
  <button class="btn btn-success" @click="refresh">Refresh</button>
  <h1>Currently connected users</h1>
  <table class="table table-condensed table-striped">
    <thead>
      <th>Id</th>
      <th>Name</th>
      <th>Version</th>
      <th>Force Reload</th>
    </thead>
    <tbody>
      <tr v-for="user in connectedUsers" :key="user.key">
        <td>{{ user.connectionId }}</td>
        <td>{{ user.username }}</td>
        <td>{{ user.version }}</td>
        <td><button class="btn btn-danger btn-sm" @click="forcePageReload(user.connectionId)">Force page-reload</button></td>
      </tr>
    </tbody>
  </table>
  <h1>Logs</h1>
  <table class="table table-sm table-striped">
    <thead></thead>
    <tbody>
      <tr v-for="log in logs" :key="log.id">
        <td>{{ log.insertDate }}</td>
        <td>{{ log.logger }}</td>
        <td>{{ log.message }}</td>
        <td>{{ log.level }}</td>
        <td>{{ log.exception }}</td>
      </tr>
    </tbody>
  </table>
  <div v-for="log in logs" :key="log.id">{{ log.insertDate }}</div>
</div>
